import React, { isValidElement } from 'react';
import { LeftOutline } from 'antd-mobile-icons';
import { isFunction } from 'lodash';
import classNames from 'classnames';
import TiSpin from '../TiSpin/index.js';
import './style/index.less.js';

var TiPage = function TiPage(props) {
  var _a = props.headerVis,
    headerVis = _a === void 0 ? true : _a,
    _b = props.backIcon,
    backIcon = _b === void 0 ? /*#__PURE__*/React.createElement(LeftOutline, {
      style: {
        fontSize: '24px'
      }
    }) : _b,
    title = props.title,
    onBack = props.onBack,
    extra = props.extra,
    loading = props.loading,
    className = props.className,
    style = props.style,
    bodyClassName = props.bodyClassName,
    _c = props.bodyStyle,
    bodyStyle = _c === void 0 ? {} : _c,
    children = props.children;
  var rootCls = classNames('ti-page', className);
  var bodyCls = classNames('ti-page-body', bodyClassName);
  var handleBack = function handleBack() {
    if (! /*#__PURE__*/isValidElement(backIcon)) {
      return;
    }
    if (isFunction(onBack)) {
      onBack();
    }
  };
  return /*#__PURE__*/React.createElement(TiSpin, {
    presetStyle: "spin",
    size: "large",
    loading: loading
  }, /*#__PURE__*/React.createElement("div", {
    className: rootCls,
    style: style
  }, headerVis ? /*#__PURE__*/React.createElement("div", {
    className: "ti-page-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-page-header-left",
    onClick: handleBack
  }, backIcon), /*#__PURE__*/React.createElement("div", {
    className: "ti-page-header-middle"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "ti-page-header-right"
  }, extra ? extra : null)) : null, /*#__PURE__*/React.createElement("div", {
    className: bodyCls,
    style: bodyStyle
  }, children)));
};

export { TiPage as default };
